import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomizedSwitch, ToolInfo } from 'components';
import { systemActions } from 'store';
import { orgIntegrationEnums, OrgIntegrations, Images } from 'utils';
import { SupervisionSettings } from './supervisionSettings';
import { EligibilityAutoCheckSettings } from './eligibilityAutoCheckSettings';
import {StaffCompliance} from "./staffCompliance";
import { MembersPortalSettings } from './membersPortalSettings';
import { DiagnosisMatchSettings } from './diagnosisMatchSettings';

export const OtherSettings = ({}) => {
    const company = useSelector((state) => state.system.company);
    const dispatch = useDispatch();
    const [companyPermissions, setCompanyPermissions] = useState({
        voiceNote: false,
        cSession: false,
    });
    const { cSession, voiceNote, cSessionInfo, voiceNoteInfo } = OrgIntegrations();

    useEffect(() => {
        dispatch(systemActions.getCompany());
    }, [dispatch]);

    useEffect(() => {
        if (company?.id) {
            setCompanyPermissions({
                voiceNote: voiceNote,
                cSession: cSession,
            });
        }
    }, [company]);

    const changeCompanyPermissions = (type, settingType) => {
        const params = {
            ...companyPermissions,
        };
        params[type] = !params[type];
        setCompanyPermissions(params);

        const sendParams = {
            settingsType: settingType,
            isActive: params[type],
        };
        dispatch(systemActions.changeAiIntegration(sendParams));
    };

    const showAiCard = voiceNoteInfo || cSessionInfo;

    return (
        <div className="other-settings">
            <div className="other-settings-grid">
                {/* ---- AI & Session Features ---- */}
                {showAiCard && (
                    <div className="settings-card">
                        <div className="settings-card-header">
                            <div className="settings-card-icon violet">
                                <img src={Images.otherSettingsAi} alt="icon"/>
                            </div>
                            <p className="settings-card-title">AI & Session Features</p>
                        </div>
                        <div className="settings-card-body">
                            {voiceNoteInfo && (
                                <div className="ai-feature-row">
                                    <div className="ai-feature-text">
                                        <p className="ai-feature-title">AI Voice Transcription & Summarization</p>
                                        <p className="ai-feature-desc">Transcribe session recordings and generate AI note summaries.</p>
                                    </div>
                                    <CustomizedSwitch
                                        checkedBgColor={'#7F56D9'}
                                        checked={companyPermissions?.voiceNote}
                                        handleClick={() => changeCompanyPermissions('voiceNote', orgIntegrationEnums.VOICE_NOTE)}
                                    />
                                </div>
                            )}
                            {cSessionInfo && (
                                <div className="ai-feature-row">
                                    <div className="ai-feature-text">
                                        <p className="ai-feature-title">Real-Time Client Session Features</p>
                                        <p className="ai-feature-desc">Enable live client session tools and real-time capture.</p>
                                    </div>
                                    <CustomizedSwitch
                                        checkedBgColor={'#7F56D9'}
                                        checked={companyPermissions?.cSession}
                                        handleClick={() => changeCompanyPermissions('cSession', orgIntegrationEnums.C_SESSION)}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* ---- BACB Supervision Settings ---- */}
                <div className="settings-card">
                    <div className="settings-card-header">
                        <div className="settings-card-icon blue">
                            <img src={Images.otherSettingsBcba} alt="icon"/>
                        </div>
                        <p className="settings-card-title">BACB Supervision Settings</p>
                    </div>
                    <div className="settings-card-body">
                        <SupervisionSettings />
                    </div>
                </div>

                {/* ---- Eligibility Verification ---- */}
                <div className="settings-card">
                    <div className="settings-card-header">
                        <div className="settings-card-icon blue">
                            <img src={Images.otherSettingsElig} alt="icon"/>
                        </div>
                        <p className="settings-card-title">Eligibility Verification</p>
                    </div>
                    <div className="settings-card-body">
                        <EligibilityAutoCheckSettings />
                    </div>
                </div>


                {/* ---- Staff Compliance ---- */}
                <div className="settings-card">
                    <div className="settings-card-header">
                        <div className="settings-card-icon blue">
                            <img src={Images.staffCompliance} alt="icon"/>
                        </div>
                        <p className="settings-card-title">System Preferences</p>
                    </div>
                    <div className="settings-card-body">
                        <StaffCompliance />
                    </div>
                </div>

                {/* ---- Billing & Diagnosis ---- */}
                <div className="settings-card">
                    <div className="settings-card-header">
                        <div className="settings-card-icon blue">
                            <img src={Images.billingAndDiagnosis} alt="icon"/>
                        </div>
                        <p className="settings-card-title">Billing & Diagnosis</p>
                    </div>
                    <div className="settings-card-body">
                        <DiagnosisMatchSettings />
                    </div>
                </div>

                {/* ---- Client Portal Access ---- */}
                <div className="settings-card">
                    <div className="settings-card-header">
                        <div className="settings-card-icon blue">
                            <img src={Images.personIcon} alt="icon"/>
                        </div>
                        <p className="settings-card-title">Client Portal Access</p>
                        <ToolInfo
                            text={'Choose which completed clinical records client contacts can view in the members portal.'}
                            iconStyle={{ marginTop: 4 }}
                        />
                    </div>
                    <div className="settings-card-body">
                        <MembersPortalSettings />
                    </div>
                </div>

            </div>
        </div>
    );
};
